import { NvIconButtonModule } from 'Src/nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { NvPillModule } from './../../../../../nvps-libraries/design/nv-pill/nv-pill.module';
import { PaginatorComponent } from './paginator.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [PaginatorComponent],
  imports: [NvPillModule, NvIconButtonModule],
  exports: [PaginatorComponent],
  providers: [],
})
export class PaginatorModule {}
